import {Auth, CognitoUser} from "@aws-amplify/auth";

export default {
  signUp: async (username: string, password: string, firstName: string, lastName: string, email: string) => {
    return await Auth.signUp({
      username: username,
      password: password,
      attributes: {
        email: email,
        given_name: firstName,
        family_name: lastName
      },
    });
  },
  confirmSignUp: async (email: string, confirmationCode: string) => {
    return await Auth.confirmSignUp(email, confirmationCode);
  },

  resendEmailVerificationCode: async (email: string) => {
    return await Auth.resendSignUp(email);
  },

  signIn: async (username: string, password: string): Promise<CognitoUser> => {
    return await Auth.signIn(username, password);
  },

  signOut: async () => {
    return await Auth.signOut();
  },

  forgotPassword: async (email: string) => {
    return await Auth.forgotPassword(email);
  },

  forgotPasswordVerification: async (email: string, code: string, password: string) => {
    return await Auth.forgotPasswordSubmit(email, code, password);
  },

  currentUser: async () => {
    try {
      return await Auth.currentAuthenticatedUser();
    } catch (error) {
      return false;
    }
  }

};
